import { render, staticRenderFns } from "./SeguimientoReclamo.vue?vue&type=template&id=04269db6&scoped=true&lang=pug&"
import script from "./SeguimientoReclamo.vue?vue&type=script&lang=js&"
export * from "./SeguimientoReclamo.vue?vue&type=script&lang=js&"
import style0 from "./SeguimientoReclamo.vue?vue&type=style&index=0&id=04269db6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04269db6",
  null
  
)

export default component.exports